import { faCircleArrowDown } from "@fortawesome/pro-regular-svg-icons/faCircleArrowDown";
import * as React from "react";

import { MprcIconFa, MprcIconFaProps } from "../MprcIconFa";

export const IconCircleArrowDown: React.FC<Omit<MprcIconFaProps, "icon">> = (props) => {
    return <MprcIconFa {...props} icon={faCircleArrowDown} />;
};
